import {APIHOST} from "@/settings";
import SessionStorage from "sessionstorage";
import axios from "axios";

class ProductService {
    sync(products) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/SyncProductDirectory`, {
            Products: products
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAll({sortBy, sortDesc, skip, limit, search}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ProductDirectory`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getSpecifications({sortBy, sortDesc, skip, limit, search, contractor}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ProductSpecification`, {
            params: {
                sortBy: typeof(sortBy) === 'string' ? sortBy: null,
                desc: typeof(sortDesc) === 'boolean' ? sortDesc : null,
                skip: typeof(skip) === 'number' ? skip : null,
                limit: typeof(limit) === 'number' ? limit : null,
                q: typeof(search) === 'string' ? search: null,
                contractor: typeof(contractor) === 'string' ? contractor: null
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    editSpecification(id, {ownerProduct, contractorProduct, contractorInn}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ProductSpecification`,  {
            ContractorInn: contractorInn,
            OwnerProduct: ownerProduct,
            ContractorProduct: contractorProduct
        },{
            params: {
                id: id
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }
}

export default new ProductService();